var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.04884,
    cy: 7.70802,
    r: 6.72169,
    fill: "#1977F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66575 9.65125L9.96351 7.70781H8.09947V6.44684C8.09947 5.91561 8.35942 5.39667 9.19502 5.39667H10.0429V3.74247C10.0429 3.74247 9.27347 3.61108 8.53807 3.61108C7.00298 3.61108 5.99912 4.54121 5.99912 6.2266V7.70781H4.29199V9.65125H5.99912V14.3482C6.3413 14.4021 6.69199 14.4295 7.04929 14.4295C7.4066 14.4295 7.75729 14.4011 8.09947 14.3482V9.65125H9.66575Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogin);
export default __webpack_public_path__ + "static/media/facebookLogin.43d5c3428f9eb462908c518107fc0e08.svg";
export { ForwardRef as ReactComponent };